import * as actionTypes from "../actions/products/actionTypes";

const products = (
  state = {
    startProject: {},
    gettingStartProject: false,
    getStartProjectSuccess: false,
    getStartProjectError: false,
    getStartProjectErrorMessage: "",
    openPurchaseStartProjectModal: false,
    submittingPurchaseStartProject: false,
    purchaseStartProjectFailed: false,
    purchaseStartProjectFailedMessage: ""
  },
  action
) => {
  switch (action.type) {
    case actionTypes.GETTING_START_PROJECT_PRODUCT:
      return Object.assign({}, state, {
        startProject: {},
        gettingStartProject: true,
        getStartProjectSuccess: false,
        getStartProjectError: false,
        getStartProjectErrorMessage: ""
      });
    case actionTypes.GET_START_PROJECT_PRODUCT_FAILED:
      return Object.assign({}, state, {
        startProject: {},
        gettingStartProject: false,
        getStartProjectSuccess: false,
        getStartProjectError: true,
        getStartProjectErrorMessage: action.payload.message
      });
    case actionTypes.GET_START_PROJECT_PRODUCT_SUCCESS:
      return Object.assign({}, state, {
        startProject: action.payload.startProject,
        gettingStartProject: false,
        getStartProjectSuccess: true,
        getStartProjectError: false,
        getStartProjectErrorMessage: ""
      });
    case actionTypes.SET_PURCHASE_START_PROJECT_MODAL:
      return Object.assign({}, state, {
        openPurchaseStartProjectModal: action.payload.isOpen
      });
    case actionTypes.RESET_PURCHASE_START_PROJECT_MODAL:
      return Object.assign({}, state, {
        openPurchaseStartProjectModal: false,
        submittingPurchaseStartProject: false,
        purchaseStartProjectFailed: false,
        purchaseStartProjectFailedMessage: ""
      });
    case actionTypes.START_PURCHASE_START_PROJECT_SUBMIT:
      return Object.assign({}, state, {
        submittingPurchaseStartProject: true,
        purchaseStartProjectFailed: false,
        purchaseStartProjectFailedMessage: ""
      });
    case actionTypes.PURCHASE_START_PROJECT_FAILED:
      return Object.assign({}, state, {
        submittingPurchaseStartProject: false,
        purchaseStartProjectFailed: true,
        purchaseStartProjectFailedMessage: action.payload.message
      });
    default:
      return state;
  }
};

export default products;
